import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const askFile = data => {
  const projectId = localStorage.getItem("project_id");
  const end_url = data.isNotReport ? `${data.route}` : `reports/${data.route}`;
  return Request({
    method: data.method,
    url: `${baseUrl}/projects/${projectId}/${end_url}`,
    needToken: true,
    data: data.method === "post" ? data.filters : {},
    params: data.method === "get" ? data.filters : {}
  });
};
export const checkFiles = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: 'get',
    url: `${baseUrl}/projects/${projectId}/files?paginate=false`,
    needToken: true,
  });
};
